import { render, staticRenderFns } from "./GoToBasketButton.vue?vue&type=template&id=620ebc40&scoped=true"
import script from "./GoToBasketButton.vue?vue&type=script&lang=js"
export * from "./GoToBasketButton.vue?vue&type=script&lang=js"
import style0 from "./GoToBasketButton.vue?vue&type=style&index=0&id=620ebc40&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "620ebc40",
  null
  
)

export default component.exports